import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "../lib/api";

const MAX_RETRIES = 4;
const RETRY_INTERVAL_MS = 2500;

export default function BillingSuccessPage() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("お支払いを確認しています...");
  const retriesRef = useRef(0);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const accountState = await api.getMe();
        if (cancelled) return;

        if (accountState.plan === "paid") {
          setMessage("ご契約ありがとうございます！");
          setTimeout(() => {
            if (!cancelled) navigate("/home", { replace: true });
          }, 1500);
          return;
        }
      } catch {
        // 取得失敗は無視してリトライ
      }

      retriesRef.current += 1;
      if (retriesRef.current >= MAX_RETRIES) {
        if (!cancelled) {
          setMessage("まもなく反映されます。ホームに移動します...");
          setTimeout(() => {
            if (!cancelled) navigate("/home", { replace: true });
          }, 2000);
        }
        return;
      }

      setTimeout(() => {
        if (!cancelled) void check();
      }, RETRY_INTERVAL_MS);
    };

    const timer = setTimeout(() => {
      if (!cancelled) void check();
    }, RETRY_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#FDF8F5] px-6 text-center">
      <div className="w-full max-w-sm rounded-[1.8rem] border border-[#EADBC8] bg-white px-8 py-10 shadow-[0_16px_40px_rgba(166,124,82,0.12)]">
        <p className="text-4xl">✓</p>
        <h1 className="mt-4 text-lg font-black text-[#5D4D46]">お支払いが完了しました</h1>
        <p className="mt-3 text-sm font-medium leading-6 text-[#7B6861]">{message}</p>
      </div>
    </div>
  );
}
